module.exports = __webpack_public_path__ + "img/vers_03-04.bf73afc5.svg";